export enum GenericCrusherTypes {
  CONE_CRUSHER = 'Cone crusher',
  GYRATORY_CRUSHER = 'Gyratory crusher',
  JAW_CRUSHER = 'Jaw crusher',
  VSI = 'VSI crusher',
  HSI = 'HSI crusher',
  HYBRID = 'Hybrid crusher',
  SAG_MILL = 'SAG mill',
  AG_MILL = 'AG mill',
  BALL_MILL = 'Ball mill',
  ROD_MILL = 'Rod mill',
  HPGR = 'HPGR',
}

export interface GenericCrusherDataInterface {}

export interface GenericCrusherMapInterface {
  [modelType: string]: GenericCrusherDataInterface;
}
